export const name = 'translationsService' as const
export { VSM_EDITOR_CONFIGS_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/viewer-service-translations' as const
export const MountedTranslationsServicesSymbol = Symbol('MountedTranslationsServices')
